import React, { 
  useCallback, useContext, useEffect, useMemo, useState 
} from 'react';

const ToastContext = React.createContext({
  isShown: false,
  toastText: '',
  showToast: () => {},
})

export const useToastContext = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toastText, setToastText] = useState('')
  const [isShown, setShown] = useState(false);

  const showToast = useCallback((toastValue) => {
    if (isShown) {
      console.error('Attempted to show toast value before previous value was cleared', toastValue);
      return;
    }
    if (toastValue && toastValue.length) {
      setToastText(toastValue);
    }
  }, [isShown])

  useEffect(() => {
    let timer;
    if (toastText?.length) {
      setShown(true);
      timer = setTimeout(() => {
        setShown(false);
      }, 1500);
    } else if (!toastText?.length) {
      setShown(false);
    }

    return () => clearTimeout(timer);
  }, [toastText])

  useEffect(() => {
    let timer;
    if (!isShown) {
      timer = setTimeout(() => {
        setToastText('');
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [isShown])

  const toastContextValue = useMemo(() => ({
    isShown, toastText, showToast
  }), [isShown, toastText, showToast])

  return (
    <ToastContext.Provider value={toastContextValue}>
      { children }
    </ToastContext.Provider>
  )
}
